import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import AppLogo from "@/features/ui/app-logo";
import AppSelect from "@/features/line-sheet-sets/app-select";
import AppButton from "@/features/line-sheet-sets/app-button";
import useWrappedNavigate from "@/features/ui/hooks/use-wrapped-navigate";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import AppLanguageSelector from "@/features/ui/app-language-selector";
import { Trans } from "react-i18next";

export default function _404Page() {
  const navigate = useWrappedNavigate();
  const { tSentence, tTitle } = useI18nHelper();

  return (
    <Flex
      maxW="440px"
      w="100%"
      backgroundColor={"#FFF"}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      border="0.5px solid #D4D4D1"
      borderRadius="8px"
      padding={"28px 0px"}
      gap="24px"
      position="relative"
    >
      <AppLogo />
      <Heading fontSize="64px" fontWeight={"700"} color={"#444444"}>
        404
      </Heading>
      <Text
        fontSize={"32px"}
        fontWeight={"700"}
        color={"#444444"}
        textAlign={"center"}
      >
        <Trans
          i18nKey={"error_page:404_title"}
          components={{
            br: <br />,
          }}
        />
      </Text>
      <Text
        padding={"0 80px"}
        fontSize={"14px"}
        textAlign={"center"}
        minHeight={"269px"}
      >
        <Trans
          i18nKey={"error_page:404_description"}
          components={{
            br: <br />,
          }}
        />
      </Text>
      {/*{socialButtons}*/}
      <Box width={"100%"} padding={"0 80px"}>
        <AppButton
          variant={"gray"}
          width={"100%"}
          size={"large"}
          height={"100%"}
          onClick={() => {
            navigate(-1);
          }}
        >
          {tTitle("error_page:go_back")}
        </AppButton>
      </Box>

      <Text fontSize={"12px"}>© UNO Trading Corp.</Text>
      <AppLanguageSelector />
    </Flex>
  );
}
